import './vendor.js';
import './components/devicecheck.js';
import './components/gtm-tracking.js';

import './components/ajax-load-more.js';
import './components/favorite-articles.js';
import './components/update-header.js';
import './components/premium-content.js';
import './components/smooth-scrolling.js';
import './components/filter-bar.js';
import './components/filter-menu.js';
import './components/search.js';
import './components/sliders.js';
import './components/anchor-bar.js';
import './components/progress-bar.js';
import './components/character-limit.js';
// import './components/related-articles.js';
import './components/trainingform.js';
import './components/training-progress.js';
import './components/training-filter.js';
import './components/contact-form.js';
import './components/text-read-more.js';
import './components/iforms.js';
import './components/modify-list.js';
import './components/iedereen-heeft-wat.js';
import './components/stel-vraag.js';
import './components/clickable-div.js';
import toggle from './components/toggle';
import progressLine from './components/progress-line';
import stickySubmitButton from './components/sticky-submit-button';
// import stickySidebarCheckout from './components/sticky-sidebar-checkout';

import './main.js';

toggle();
progressLine();
stickySubmitButton();
// stickySidebarCheckout();
